import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class DevicePositionService {
  constructor(
    private http: HttpClient
  ) { }

  public getDevicePosition(companyId: string): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/companies/${companyId}/position`
    );
  }

  public updateDevicePosition(companyId: string, deviceId: string): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/companies/${companyId}/devices/${deviceId}/position`, []
    );
  }
}